// extracted by mini-css-extract-plugin
export default {"side-bar-close":"SidebarClose_side-bar-close__JWFD9"};